import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { WagmiProvider } from "wagmi";
import { createWeb3Modal } from "@web3modal/wagmi";
import { config, WALLETCONNECT_PROJECT_ID } from "./config/wagmi";
import { App } from "./App";
import "./index.css";

const queryClient = new QueryClient();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
createWeb3Modal({ wagmiConfig: config as any, projectId: WALLETCONNECT_PROJECT_ID });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <HashRouter>
          <App />
        </HashRouter>
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>,
);
